import { PairMonthActivations } from '../model/pairMonthActivations.class';
import { Version } from './../model/version.class';
import { Component, Input } from '@angular/core';
import { UserService } from '../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Media } from '../model/media.class';
import { Modal } from 'angular2-modal/plugins/bootstrap';
import { RequestOptions } from '@angular/http';

@Component({
    selector: 'app-media-detail',
    templateUrl: './media.detail.component.html'
})
export class MediaDetailComponent {
    public media: Media;
    public message = '';
    public newVersionMessage = '';
    public mediaDeleteMessage = '';
    public imageUrl: string;
    public stats: PairMonthActivations[];
    public versions: Version[];
    public baseVersionForNew: Version | undefined;

    constructor(public userService: UserService, private route: ActivatedRoute, private router: Router, public modal: Modal) {
        this.route.params.subscribe(
            (params) => {
                userService.get(params['id'], 'media').subscribe(
                    (media) => {
                        this.media = media as Media;
                        this.imageUrl = userService.determineImageUrl(this.media);
                        userService.getPenStats(this.media.mid).subscribe(
                            (penStats) => {
                                this.stats = penStats as PairMonthActivations[];
                            }
                        );
                        userService.getBy('version', this.media.mediaId, 'media').subscribe(data => {
                            this.versions = data as Version[];
                            //Select highest version as base version by default
                            this.baseVersionForNew = this.versions.reduce((latest, v) => {
                                return v.number > (latest ? latest.number : -Infinity) ? v : latest
                            }, undefined);
                        });
                    }
                );
            }
        );
    }

    lock() {
        this.media.mediaStatus = this.userService.None;
        this.userService.update(this.media, 'media').subscribe();
    }

    approve() {
        this.media.mediaStatus = this.userService.Approved;
        this.userService.update(this.media, 'media').subscribe();
    }

    createVersion() {
        this.newVersionMessage = 'Eine neue Version wird erstellt. Dies kann je nach Größe des Mediums einige Sekunden bis Minuten dauern...'
        let url = `version/new/${this.media.mediaId}`
        if (this.baseVersionForNew !== undefined) { //Omit optional param if no base version is specified, backend picks latest by default
            url += `?versionNumber=${this.baseVersionForNew.number}`;
        }
        this.userService.getByUrl(url).subscribe(
            (data) => {
                const version = data as Version;
                this.router.navigate(['publisher/detail', this.media.publisher.publisherId]);
            },
            (error) => this.message = 'Fehler beim erstellen der neuen Version'
        );
    }

    delete() {
        this.modal.confirm()
            .size('sm')
            .isBlocking(true)
            .showClose(true)
            .keyboard(27)
            .titleHtml('Medium wirklich löschen?')
            .cancelBtn('Abbrechen')
            .open().then((resultPromise) => {
                this.mediaDeleteMessage = 'Medium wird gelöscht. Dies kann je nach Größe des Mediums einige Sekunden bis Minuten dauern...'
                return resultPromise.result.then(
                    (result) => {
                        this.userService.delete(this.media.mediaId, 'media').subscribe(
                            (user) => this.router.navigate(['publisher/detail', this.media.publisher.publisherId]),
                            (err) => this.mediaDeleteMessage = err._body)
                    },
                    (error) => {
                         this.mediaDeleteMessage = 'Löschen fehlgeschlagen!';
                    });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/mediaDetail/media.detail.component.ts